import { v4 as uuidv4 } from 'uuid';

/**
 * A branded type representing a UUID string.
 * This type is used to distinguish UUIDs from regular strings at compile time.
 *
 * @example
 * const id: UUID = generateUUID();
 * const typedId = '123e4567-e89b-12d3-a456-426614174000' as UUID;
 */
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

/**
 * Generates a random UUID (Universally Unique Identifier) v4.
 * This is a cross-platform alternative to crypto.randomUUID() that works
 * in both Node.js and browser environments.
 *
 * @returns A newly generated UUID string.
 *
 * @example
 * const id: UUID = generateUUID();
 * console.log(id); // e.g., "9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d"
 */
export function generateUUID(): UUID {
  const id: UUID = uuidv4() as UUID;
  return id;
}
